export enum AnalyticsNamespace {
	SchedulePage = 'SchedulePage',
	AdjacentAppointments = 'AdjacentAppointments',

	PatientLookupHeader = 'PatientLookupHeader',
	PatientLookupPage = 'PatientLookupPage',

	Document = 'Document',
	DocumentListRow = 'DocumentListRow',
	RecommendedDx = 'RecommendedDx',
	NoteWizard = 'NoteWizard',
	AIAssessmentEvent = 'AIAssessmentEvent',
	ShowMoreClicked = 'ShowMoreClicked',

	AdminUsersTable = 'AdminUsersTable',
	AdminUserModal = 'AdminUserModal',
	AdminMeasuresConfiguration = 'AdminMeasuresConfiguration',

	RafScore = 'RafScore',

	FileManagerPage = 'FileManagerPage',

	PatientsWorkList = 'PatientsWorkList',

	NewReleaseNotification = 'NewReleaseNotification',
}

export const ANALYTICS_TEMPLATES = {
	getClickEventName: (namespace: AnalyticsNamespace) => `${namespace} Click`,
	getLoadEventName: (namespace: AnalyticsNamespace) => `${namespace} Load`,
} as const satisfies Record<
	`get${string}EventName`,
	(namespace: AnalyticsNamespace) => `${typeof namespace} ${string}`
>;
